<template>
  <v-container>
    <h2 class="text-center font-weight-medium mt-4">INICIAR TESTE</h2>
    <h4 class="text-center mb-4 font-weight-regular">Instruções</h4>
    <v-stepper
      :light="true"
      width="480"
      v-model="e1"
      class="mx-sm-16 mx-xl-16 pb-4"
    >
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1"
          >TERMO DE ACEITE</v-stepper-step
        >

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">INFORMAÇÕES</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">INÍCIO</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="mb-12" height="280" flat>
            <p
              style="font-size: 20px"
              class="blockquote text-justify px-4 font font-weight-regular"
            >
              Declaro que aceito realizar o teste proposto de livre e espontânea
              vontade, me comprometendo em responder as perguntas de acordo com
              minha opinião e posicionamento.
            </p>
            <v-checkbox
              class="ml-4"
              v-model="checkbox"
              :label="`Aceito os termos`"
            ></v-checkbox>
          </v-card>
          <div class="text-center">
            <v-btn  @click="back">Voltar</v-btn>
            <v-btn class="ml-8" color="primary" :disabled="!checkbox" @click="e1 = 2"
              >Continuar</v-btn
            >
          </div>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card class="mb-12" :elevation="0">
            <p style="font-size: 20px" class="text-justify font-weight-normal">
              O teste a seguir tem a finalidade de saber como você se posiciona
              frente a determinadas situações.
            </p>
            <p style="font-size: 20px" class="text-justify font-weight-normal">
              Você deve responder com sua opinião verdadeira a cada pergunta,
              pois não há respostas certas ou erradas.
            </p>
            <p style="font-size: 20px" class="text-justify font-weight-normal">É importante você responder todas as perguntas.</p>
            <p style="font-size: 20px" class="text-justify font-weight-normal">
              Para cada pergunta aparecerá uma barra de tempo e você terá 20
              segundos para responder, não será possível voltar para a pergunta
              quando o tempo acabar.
            </p>
            <p style="font-size: 20px" class="text-justify font-weight-normal">O tempo de duração do teste é de aproximadamente 35 - 40 minutos.</p>
          </v-card>
          <div class="text-center">
            <v-btn  @click="e1 = 1">Voltar</v-btn>
            <v-btn class="ml-8" color="primary" @click="e1 = 3"
              >Continuar</v-btn
            >
          </div>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card class="mb-12" :elevation="0">
            <p style="font-size: 20px" class="mt-8 mb-8 text-center font-weight-normal">
              Agora você vai iniciar o teste, lembre-se é importante que
              responda verdadeiramente.
            </p>

            <p class="text-center font-weight-bold">BOA SORTE!</p>
          </v-card>
          <div class="text-center">
            <!--<v-btn class="ml-4" color="primary">Continuar</v-btn>-->
            <v-row justify="center">
              <v-btn  @click="e1 = 2">Voltar</v-btn>
              <v-dialog v-model="dialog" persistent max-width="290">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    class="ml-8"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    >Continuar</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title class="headline">Iniciar teste</v-card-title>
                  <v-card-text
                    >Tem certeza que deseja iniciar o teste?</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">Voltar</v-btn>
                    <v-btn  class="ml-8" color="primary" dark @click="startAssessment"
                      >Iniciar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-dialog v-model="dialog2" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="font-weight-medium text-center pt-4">
          Estamos preparando um novo teste...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0 mt-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { router } from "../router";

export default {
  data() {
    return {
      e1: 1,
      dialog: false,
      dialog2: false,
      checkbox: false,
    };
  },
  methods: {
    startAssessment() {
      this.dialog = false;
      this.dialog2 = true;
      router.replace({ name: "TestV2", params: {terms: true} });

    },
    back() {
      router.back();
    },
  },
};
</script>
